export default __webpack_public_path__ + "static/about-image-5119f0a4309c3442c923938a6d20e776.jpg";